import { LocaleInput } from '../index.js'

export default {
  code: 'sm',
  buttonText: {
    prev: 'Talu ai',
    next: 'Mulimuli atu',
    today: 'Aso nei',
    month: 'Masina',
    week: 'Vaiaso',
    day: 'Aso',
    list: 'Faasologa',
  },
  weekText: 'Vaiaso',
  allDayText: 'Aso atoa',
  moreLinkText: 'sili atu',
  noEventsText: 'Leai ni mea na tutupu',
} as LocaleInput
